const regexUtil = (key: string): RegExp|null => {
  switch (key) {
    case 'word':
      return new RegExp(/\w/);
    case 'en-zh':
      return new RegExp(/([A-Za-z0-9$&+,:;=?@#|'<>.^*()%!-\\ ]*)(.*)/);
    default:
      return null;
  }
};

export default regexUtil;
